
import FooterLogo from '../../assests/images/white.png';
export default function Footer() {
  return (
    <footer className="bg-[#4F301F] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col items-center text-center space-y-6">
          <img 
            src={FooterLogo} 
            alt="Roaffees - Brewing as an Artform" 
            className="h-16 w-auto"
          />
          
          <p className="text-gray-200 text-sm leading-relaxed max-w-2xl">
            Crafting Delhi's finest coffee and matcha culture with premium quality and ethical sourcing.
          </p>
          
          <div className="flex space-x-6">
            <a href="https://www.instagram.com/roaffees" className="text-gray-200 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-instagram-fill text-xl"></i>
            </a>
            <a href="https://www.facebook.com/people/Roaffees/61568425757076/" className="text-gray-200 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a href="https://www.youtube.com/@Roaffees/shorts" className="text-gray-200 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-youtube-fill text-xl"></i>
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-400 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-200 mb-4 md:mb-0">&copy; 2025 Roaffees. All rights reserved.</p>
          
          <div className="flex space-x-6 text-sm text-gray-200">
            <a href="/privacy-policy" className="hover:text-white transition-colors duration-300 cursor-pointer">Privacy Policy</a>
            <a href="/terms-of-service" className="hover:text-white transition-colors duration-300 cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
